import apiCore from '../../utils/api-core';

export function uploadFile(data) {
	return apiCore.post('/api/v1/files/logo', data);
}

export function uploadImage(data) { 
	return apiCore.post('/api/v1/files/icon', data);
}